import React from 'react';
import {Field} from 'redux-form/immutable';
import {CheckboxGroupField} from 'redux-form-antd'
import {
    required,
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

const SseS2 = props => {
    const ans = '最困難科目'
    const select_arr = [
        {
            value: '1',
            label: '國語文'
        },
        {
            value: '2',
            label: '本土語文'
        },
        {
            value: '3',
            label: '新住民語文'
        },
        {
            value: '4',
            label: '英語文'
        },
        {
            value: '5',
            label: '數學'
        },
        {
            value: '6',
            label: '自然科學'
        },
        {
            value: '7',
            label: '社會'
        },
        {
            value: '8',
            label: '健康與體育'
        },
        {
            value: '9',
            label: '健康教育'
        },
        {
            value: '10',
            label: '體育'
        },
        {
            value: '11',
            label: '藝術'
        },
        {
            value: '12',
            label: '表演藝術'
        },
        {
            value: '13',
            label: '視覺藝術'
        },
        {
            value: '14',
            label: '音樂'
        },
        {
            value: '15',
            label: '生活課程'
        },
        {
            value: '16',
            label: '綜合活動  '
        }
    ]
    return (
        <div>
            <Field {...formItemLayout} validate={required} component={CheckboxGroupField} options={select_arr} label={ans} name="sse_s2"
                   type="checkbox"/>
        </div>
    )
}

export default SseS2


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseS2.jsx